<template>
  <span>

    <a href="" @click.prevent="openModal" v-if="!showTranslation"><mdb-icon icon="language"/></a>


    <mdb-modal size="lg" v-if="showTranslation">
      <mdb-modal-header class="primary-color text-white text-center" :close="false" center>
        <h4 v-if="language == 'en'">Default English</h4>
        <h4 v-if="language != 'en'">Translation to {{language}}</h4>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <mdb-input disabled type="textarea" :rows="3" v-if="language != 'en'" label="English" v-model="english"/>
        <mdb-input type="textarea" :rows="3" id="translation-input" :label="language == 'en' ? 'English Text (Default)' : 'Translation'" v-model="translation"/>
        <div class="text-info text-left">
          Translation Key: {{category}}.{{subCategory}}.{{name}}
        </div>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn :disabled="saving || !translation" @click="save" icon="save" color="success">Save</mdb-btn>
        <mdb-btn :disabled="saving"  @click="showTranslation=false" icon="times-circle" color="danger">Cancel</mdb-btn>
        <mdb-spinner v-if="saving"/>
      </mdb-modal-footer>
    </mdb-modal>
  </span>
</template>
<script>
import {mdbBtn, mdbIcon, mdbInput, mdbModal, mdbModalBody, mdbModalFooter, mdbModalHeader, mdbSpinner} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import Vue from "vue";

export default {
  name: 'translateModal',
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbBtn,
    mdbInput,
    mdbSpinner
  },
  computed: {
    language: function () {
      return this.$store.state.language
    },
  },
  props: {
    category: {
      type: String,
      default: null
    },
    subCategory: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      translatedValue: "",
      showTranslation: false,
      english: "",
      translation: "",
      saving: false

    }
  },
  methods: {

    save() {
      this.saving = true
      let url = "/admin/translate"
      let payload = {
        category: this.category,
        subcategory: this.subCategory,
        language: this.language,
        name: this.name,
        value: this.translation
      }
      api.post(url, payload).then(
        () => {
          this.showTranslation = false
          let messages = this.$i18n.getLocaleMessage(this.language)
          if (! messages.hasOwnProperty(this.category)) messages[this.category] = { }
          if (! messages[this.category].hasOwnProperty(this.subCategory)) messages[this.category][this.subCategory] = { }
          messages[this.category][this.subCategory][this.name] = this.translation
          this.$i18n.setLocaleMessage(this.language, messages)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.saving = false
      })

    },
    openModal() {
      let url = "/admin/translate/?lang=" + this.language + "&category=" + this.category + "&subcategory=" + this.subCategory + "&name=" + this.name
      api.get(url).then(
        (results) => {
          this.english = results.data.english
          this.translation = results.data.translation
          Vue.nextTick().then(function () {
            let el = document.getElementById("translation-input")
            if (el) el.focus()
          })
        });
      this.showTranslation = true
    },
  }

};
</script>
